import sortBy from 'lodash/sortBy';
import uniqBy from 'lodash/uniqBy';

import type { ControlDto } from '@src/api';
import type { ControlDtoDefId } from '@stores/dictionaryStores/controlsStore/controlsStore';

type ControlDtoWithChildren = ControlDto & {
  children?: ControlDtoWithChildren[];
  key: string;
  title: string;
};

export const toTreeView = (controls: ControlDtoDefId[]): ControlDtoWithChildren[] => {
  const output = sortBy(
    controls.filter((control) => control.repGroupCode && control.ctrlGroupCode),
    ['repGroupCode', 'ctrlGroupOrder'],
  );

  return uniqBy(output, 'repGroupCode').map((item) => ({
    repGroupCode: item.repGroupCode,
    key: item.repGroupCode ?? '',
    title: `${item.repGroupCode} - ${item.reportGroupName}`,
    children: uniqBy(
      output.filter((el) => el.repGroupCode === item.repGroupCode),
      'ctrlGroupCode',
    ).map((el) => ({
      ctrlGroupCode: el.ctrlGroupCode,
      repGroupCode: el.repGroupCode,
      key: `${el.repGroupCode} - ${el.ctrlGroupCode}`,
      title: `${el.ctrlGroupCode} - ${el.ctrlGroupName}`,
      count: controls.filter(
        (control) => control.repGroupCode === el.repGroupCode && el.ctrlGroupCode === control.ctrlGroupCode,
      ).length,
    })),
  }));
};
